// @flow
import * as React from 'react';
import AppBarStateContext from '../config/stateContext';

export default function useAppBarState() {
  return React.useContext(AppBarStateContext);
}
